import { useQuery } from '@tanstack/react-query';
import { useShallow } from 'zustand/react/shallow';

import { privateV2Api } from '@/lib/api-clients/rest-client';
import { useAccountStore } from '@/store/use-account-store';
import { handleAccountForStore } from '@/utils/handle-store-data';

export const getBalance = (apiKey?: string) => {
  return privateV2Api.get('/v2/balance', {
    ...(apiKey
      ? {
          headers: {
            'X-API-KEY': apiKey,
          },
        }
      : {}),
  });
};

export const getBalanceQueryKey = (apiKey?: string) => ['/balance', apiKey];

export default function useBalance() {
  const { hasAuth, apiKey, accGroup } = useAccountStore(
    useShallow((state) => {
      const authParams = state.getAuthParams(state.address);
      return {
        hasAuth: state.hasAuth,
        apiKey: authParams?.apiKey,
        accGroup: authParams?.accountGroup,
      };
    }),
  );

  return useQuery({
    enabled: hasAuth && !!apiKey && accGroup === 2,
    staleTime: 0,
    refetchOnWindowFocus: false,
    queryFn: () =>
      getBalance(apiKey).then((res) => {
        handleAccountForStore(res);
        return res;
      }),
    queryKey: getBalanceQueryKey(apiKey),
  });
}
